export const SIGNUP_REASON_TOUR = 'tour';
export const SIGNUP_REASON_WANT_TO_APPLY = 'wantsToApply';
export const SIGNUP_REASON_START_PREQUAL = 'startPrequal';
export const SIGNUP_REASON_BOOKMARK = 'bookmark';
export const SIGNUP_REASON_APARTMENT_LOCATOR_INVITE = 'apartmentLocatorInvite';
export const SIGNUP_REASON_SIGNUP_PAGE = 'signupPage';
export const SIGNUP_REASON_SELF_TOURING = 'selfTouring';
export const SIGNUP_REASON_TOUR_WAITLIST = 'tourWaitlist';
export const EXTENDED_SIGNUP_V1 = 'extended';
